import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/Dashboard',
      name: 'Home',
      component: () => import('@/containers/DefaultContainer'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/Dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard')
        },
        {
          path: '',
          component: () => import('@/views/Dashboard')
        },
        {
          path: '/Profile',
          meta: { label: 'Profile' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Settings/profile')
            },
            {
              path: 'Edit',
              meta: { label: 'Edit Profile' },
              name: 'EditProfile',
              component: () => import('@/views/Settings/editProfile'),
            },
            {
              path: '/changePassword',
              meta: { label: 'Change Password' },
              name: 'ChangePassword',
              component: () => import('@/views/Settings/changePassword'),
            },
          ]
        },
        {
          path: '/Users',
          meta: { label: 'Investigaor / Partner' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/users/users'),
            },
            {
              path: ':id',
              meta: { label: 'User Details' },
              name: 'User',
              component: () => import('@/views/users/user'),
            },
            {
              path: '/EditUser/:id',
              meta: { label: 'Edit User Details' },
              name: 'EditUser',
              component: () => import('@/views/users/editUser'),
            },
            {
              path: '/AddUser',
              meta: { label: 'Add User' },
              name: 'AddUser',
              component: () => import('@/views/users/addUser'),
            },
          ]
        },
        {
          path: '/Admins',
          meta: { label: 'Admins' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Admins/admins'),
            },
            {
              path: ':id',
              meta: { label: 'Admin Details' },
              name: 'ADmin',
              component: () => import('@/views/Admins/admin'),
            },
            // {
            //   path: '/EditUser/:id',
            //   meta: { label: 'Edit User Details' },
            //   name: 'EditUser',
            //   component: () => import('@/views/users/editUser'),
            // },
            {
              path: '/AddAdmin',
              meta: { label: 'Add User' },
              name: 'AddAdmin',
              component: () => import('@/views/Admins/addadmin'),
            },
          ]
        },
        
        
       
        
       
        {
          path: '/Reports',
          meta: { label: 'Reports' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Reports/reports'),
            },
            {
              path: ':id',
              meta: { label: 'Report Details' },
              name: 'ReportDetails',
              component: () => import('@/views/Reports/report'),
            },
            {
              path: '/AddReport',
              meta: { label: 'Add Report' },
              name: 'AddReport',
              component: () => import('@/views/Reports/addReport'),
            },
            {
              path: '/EditReport/:id',
              meta: { label: 'Edit Report' },
              name: 'EditReport',
              component: () => import('@/views/Reports/editReport'),
            },
          ]
        },
        {
          path: '/Map',
          meta: { label: 'Map' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Map/map'),
            },
          ]
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/pages/Login')
    },
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: () => import('../views/pages/Page404'),
      meta: {
        description: 'App 404 Page',
        requiresAuth: false
      }
    },
    {
      path: '/ServerError',
      name: 'ServerError',
      props: true,
      component: () => import('../views/pages/Page500'),
      meta: {
        description: 'App Server Error Page',
        requiresAuth: false
      }
    },

  ]
})

router.beforeEach((to, from, next) => {
  
  if (localStorage.getItem('token')) {
    var newURL = ''
    if(localStorage.getItem('role') == 'user')
     newURL = "/authenticate/user";
    
    else
     newURL = "authenticate/admin";
    axios({
      method: "POST",
      url: newURL,
      headers: {
        "token": localStorage.getItem("token")
      }
    })
      .then(response => {
        if (!response.data.status) {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          store.commit("logoutUser");
          next({
            name: 'Login'
          })
          return
        }
      })
  }
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({
      name: 'Login'
    })
    return
  }
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({
      path: '/Reports'
    })
    return
  }
  next()
})

export default router

